import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { 
  ArrowLeft, 
  Heart, 
  Users, 
  Calendar, 
  MapPin, 
  Star,
  BookOpen,
  Church,
  Globe,
  Award,
  Quote,
  Camera,
  Mail
} from 'lucide-react';

const About = () => {
  const [activeTab, setActiveTab] = useState('histoire');

  const milestones = [
    {
      year: "2006",
      title: "Les Prémices",
      description: "La Communauté « FLEURS DE LA SAINTE FAMILLE » est une Communauté de familles dont les couples sont régulièrement mariés à l’Eglise Catholique Romaine de rite latin. Elle est née de la volonté d’un certain nombre de couples chrétiens catholiques de partager leur vécu quotidien dans la prière, les enseignements et le témoignage afin de consolider leur foyer sur les plans spirituel et social. Il s’agit des couples : Carmen et Andoche GOUNLOME, Rufine et Barnabé KOUNONLA, Victoire et Godfried TSWALASSOU, Huguette et Lucien DAZOGBO, Lidwine et Romain GLELE KAKAÏ, Epiphanie et Honoré OUENSA. La plupart de ces couples sont issus d’un groupe de fiancés de la paroisse Saints Pierre et Paul d’Agla dénommé « MARIE-JOSEPH » et qui a été mis en place par le feu Père Florent NASCIMENTO. Après leur mariage religieux, la plupart des membres de ce groupe ont senti le besoin de poursuivre l’expérience du partage des vécus quotidiens du ménage et l’ont exprimé au cours de différentes rencontres.  ",
      icon: Church,
      color: "blue"
    },
    {
      year: "2007",
      title: "Fondation Officielle",
      description: "Ceci les a conduits à tenir une 1ère rencontre officielle de mise en place d’un nouveau groupe de mariés le dimanche 28 janvier 2007 sous les encouragements et la conduite du couple Armelle et Apollinaire MEDAGBE, membre des « Equipes Notre Dame » et témoin de mariage de Carmen et Andoche GOUNLOME. Huit (08) couples étaient présents à cette 1ère rencontre à savoir : Carmen et Andoche GOUNLOME, Rufine et Barnabé KOUNONLA, Victoire et Godfried TSWALASSOU, Huguette et Lucien DAZOGBO, Lidwine et Romain GLELE KAKAÏ, Carmelle et Christian ASSOSSOU, Elvire et Guy–Romain YETONGNON, Epiphanie et Honoré OUENSA. Dans une prière communautaire, sous la mouvance de l’Esprit Saint, le nom de la Communauté : « Fleurs de la Sainte Famille » a été accueilli parmi quatre propositions faites par les couples présents. Dans ce nom, les « Fleurs » découlent de la nécessité d’immortaliser le prénom du Père Florent NASCIMENTO. La Sainte Famille étant l’idéal à atteindre pour tous les couples appartenant à la Communauté. Pour les membres de la Communauté, « Fleurs » devraient aussi signifier les enfants purs, beaux et attrayants de la Sainte Famille. Les couples présents à cette rencontre ont décidé que les réunions de la Communauté auront lieu le dernier dimanche de chaque mois à partir de 15 heures et prendront fin à 18 heures. Le lieu de rencontre retenu était la Paroisse Jésus –Eucharistie de Cotonou compte tenu de l’exiguïté de la Paroisse Saints Pierre et Paul d’Agla à cette époque.",
      icon: Users,
      color: "green"
    },
    // {
    //   year: "2018",
    //   title: "Expansion Nationale",
    //   description: "L’effectif des couples devenant de plus en plus important, ceux-ci provenant de quartiers de plus en plus éloignés de la paroisse de rassemblement, il a décidé de la création de nouvelles zones. Ainsi le 4 février 2018, la zone de Calavi a été installée sur la paroisse Sainte Joséphine Bakhita d’Abomey Calavi et le 14 mars 2021, ce fut le tour de la zone d’Akpakpa sur la paroisse Sainte Thérèse de l’Enfant Jésus et de la Sainte Face d’Akpakpa PK6. Son apostolat est d’aider les familles à mener une vie conjugale épanouie dans la Fidélité à Dieu, la protection et la sauvegarde de la vie. Sa devise est  « Amour – Fidélité – Paix ». ",
    //   icon: MapPin,
    //   color: "amber"
    // },
    {
      year: "2018",
      title: "Reconnaissance Diocésaine",
      description: "Reconnaissance officielle par l'Archidiocèse de Cotonou et établissement des liens avec les autres diocèses du Bénin.",
      icon: Award,
      color: "orange"
    },
    // {
    //   year: "2030",
    //   title: "Dimension Internationale",
    //   description: "Extension de la mission vers d'autres pays d'Afrique de l'Ouest : Togo, Burkina Faso, Côte d'Ivoire.",
    //   icon: Globe,
    //   color: "red"
    // },
    {
      year: "2026",
      title: "Ère Numérique",
      description: "Lancement de la plateforme digitale et développement des outils de communication modernes pour toucher plus de familles.",
      icon: Camera,
      color: "pink"
    }
  ];

  const values = [
    {
      title: "Amour & Fidélité Conjugale ",
      description: "Promouvoir l'amour authentique entre époux, fondé sur le Christ et nourri par la prière commune.",
      icon: Heart,
      color: "red"
    },
    {
      title: "Vie Familiale",
      description: "Accompagner les familles dans leur croissance spirituelle et humaine, en mettant l'Évangile au centre du foyer.",
      icon: Users,
      color: "blue"
    },
    {
      title: "Formation Continue",
      description: "Offrir des formations spirituelles, bibliques et pratiques pour enrichir la vie de couple et de famille.",
      icon: BookOpen,
      color: "green"
    },
    {
      title: "Communion Fraternelle",
      description: "Créer des liens de fraternité authentique entre les membres, dans l'esprit de la première communauté chrétienne.",
      icon: Globe,
      color: "amber"
    }
  ];

  const founders = [
    {
      name: "Père Florent NASCIMENTO",
      role: "Fondateur et Premier Aumônier",
      description: "Prêtre visionnaire qui a posé les bases spirituelles de la communauté FSF avec une passion pour l'évangélisation des familles.",
      image: "/api/placeholder/120/120"
    },
    {
      name: "Carmen et Andoche GOUNLOME",
      role: "Premiers Responsables Laïcs",
      description: "Membre",
      image: "/api/placeholder/120/120"
    },
    {
      name: "Rufine et Barnabé KOUNONLA",
      role: "Coordinatrice Spirituelle",
      description: "Membre",
      image: "/api/placeholder/120/120"
    },
    {
        name:"Victoire et Godfried TSWALASSOU",
        role: "Animateur",
        description:"Membre",
        image: "/api/placeholder/120/120"
    },
    {
        name:"Huguette et Lucien DAZOGBO",
        role: "Volontaire",
        description:"Membre",
        image: "/api/placeholder/120/120"
    },
    {
        name:"Lidwine et Romain GLELE KAKAÏ",
        role:"Volontaire",
        description:"Membre",
        image: "/api/placeholder/120/120"
    },
    {
        name:"Epiphanie et Honoré OUENSA",
        role:"Volontaire",
        description:"Membre",
        image: "/api/placeholder/120/120"
    }

  ];

  const currentBureau = {
    diocesan: [
      {
        name: " Couple DEDJI Isabelle et Wilfrid",
        role: "Animateur Principal Diocésain (APD)",
        description: "Responsable de la coordination générale de toutes les activités de la communauté FSF au niveau diocésain.",
        image: "/api/placeholder/120/120",
        contact: "wil_dedji@yahoo.fr"
      },
      {
        name: "Couple AVONON Aubierge & Joel",
        role: "Secrétaire Générale Diocésaine (SGD)",
        description: "En charge de l'administration, de la communication et du suivi des activités diocésaines.",
        image: "/api/placeholder/120/120",
        contact: "sgd.fsf@gmail.com"
      },
      {
        name:"Couple KOUCHORO Innocentia et Marcel",
        role:"Chargé de la Spiritualité et des Affaires Sociales (CSAS)",
        description : "Prise en charges des activités spirituelles et sociales de la communauté au niveau diocésain.",
        image : "/api/placeholder/120/120",
        contact : "ssp.fsf@gmail.com",
      },
      {
        name: "Couple ZANOU Christiane et Philémon",
        role: "Trésorier Général Diocésain (TGD)",
        description: "Responsable de la gestion financière et du suivi des cotisations au niveau diocésain.",
        image: "/api/placeholder/120/120",
        contact: "tgd.fsf@gmail.com"
      },
      {
        name:"Couple TOSSOU Elsie & Parfait",
        role: "Organisateur Général (OG)",
        description :"Organisateur Général des activités de la communauté au niveau diocésain, en charge de la logistique et de la coordination des événements.",
        image: "/api/placeholder/120/120",
        contact: "org.fsf@gmail.com"
      },
      {
        name:"Couple ATINDEBAKOU Sonia & Vital",
        role : "Commissaire aux Comptes",
        description : "Veuillez à la bonne gestion de la communauté en effectuant des audits réguliers et en assurant la transparence financière.",
        image: "/api/placeholder/120/120",
        contact: "comptes.fsf@gmail.com"
      }
      // {
      //   name: "Père Michel GBAGUIDI",
      //   role: "Aumônier Diocésain",
      //   description: "Accompagnateur spirituel et conseiller théologique de la communauté diocésaine.",
      //   image: "/api/placeholder/120/120",
      //   contact: "aumonier.fsf@gmail.com"
      // }
    ],
    zones: [
      {
        name: "Zone Calavi",
        color: "blue",
        responsables: [
          {
            name: "Couple Franck Eric et Constantine MENSAH",
            role: "Animateur Principal de Zone (APZ)",
            description: "Coordination des fraternités de la zone Calavi et animation des activités zonales.",
            image: "/api/placeholder/120/120",
            contact: "apz.calavi@gmail.com"
          },         
          {
            name: "Couple Félicité et Pascal GBAGUIDI",
            role: "Secrétaire Générale de Zone (SGZ)",
            description: "Gestion administrative et communication au niveau de la zone Calavi.",
            image: "/api/placeholder/120/120",
            contact: "sgz.calavi@gmail.com"
          },
           {
            name : "Couple Cosme et Saturnine AKOHONWÉ",
            role : "Chargé de Spiritualité et des Affaires Sociales (CSAS) ",
            description : "Prise en charges des activités spirituelles et sociales de la communauté au niveau diocésain.",
            image : "/api/placeholder/120/120",
            contact : "zone.spi-calavi@gmail.com"

          },
          {
            name: "Couple Judith et Thomas AGBOMEMEWA",
            role: "Trésorier Général de Zone (TGZ)",
            description: "Gestion financière et suivi des contributions de la zone Calavi.",
            image: "/api/placeholder/120/120",
            contact: "zone.tgz-calavi@gmail.com"
          },
          {
            name:"Couple Yvette et Idelphonse ABOUTOU",
            role : "Organisateur Général de Zone (OGZ)",
            description : "Organisateur Général des activités de la communauté au niveau de la zone Calavi, en charge de la logistique et de la coordination des événements.",
            image: "/api/placeholder/120/120",
            contact: "ogz.calavi@gmail.com"
          },
          {
            name :"Couple Linda et Eliezer GOUDAYI",
            role :"Commissaire aux comptes",
            description : "Veuillez à la bonne gestion de la communauté en effectuant des audits réguliers et en assurant la transparence financière au niveau de la zone Calavi.",
            image: "/api/placeholder/120/120",
            contact : "comptes.calavi@gmail.com"
          }
        ],
        fraternites: ["FRATERNITE SAINTE JOSEPHINE BAKHITA", "FRATERNITE SAINT JEAN PAUL II", "FRATERNITE IMMACULEE CONCEPTION","FRATERNITE NOTRE DAMES DES APôTRES","FRATERNITE NOTRE DE PERTUEL SECOURS","FRATERNITE SAINT MAXIMILIEN MARIE KOLBE","FRATERNITE NOTRE DAME DE ROSAIRE"]
      },
      {
        name: "Zone Jésus Eucharistie",
        color: "green",
        responsables: [
          {
            name: "Couple Bernadette et Vincent BOSSOU ",
            role: "Animateur Principal de Zone (APZ)",
            description: "Coordination des fraternités de la zone Cotonou et animation des activités zonales.",
            image: "/api/placeholder/120/120",
            contact : "apz.je@gmail.com"
          },
          {
            name: "Couple Léa et Charles KINHOUANDE",
            role: "Secrétaire Générale de Zone (SGZ)",
            description: "Gestion administrative et communication au niveau de la zone Cotonou.",
            image: "/api/placeholder/120/120",
            contact : "sgz.je@gmail.com"
          },
           {
            name : "couple Irène & Georges KOUCHORO",
            role : "Chargé de Spiritualité et des Affaires Sociales (CSAS) ",
            description : "Prise en charges des activités spirituelles et sociales de la communauté au niveau diocésain.",
            image : "/api/placeholder/120/120",
            contact : "zone.spi-je@gmail.com"
          },
          {
            name: "Couple Marlène et Casimir GNANHO",
            role: "Trésorier Général de Zone (TGZ)",
            description: "Gestion financière et suivi des contributions de la zone Calavi.",
            image: "/api/placeholder/120/120",
            contact: "zone.tgz-je@gmail.com"
          },
          {
            name:"Couple Agathe et Abel KPEKOU",
            role : "Organisateur Général de Zone (OGZ)",
            description : "Organisateur Général des activités de la communauté au niveau de la zone Calavi, en charge de la logistique et de la coordination des événements.",
            image: "/api/placeholder/120/120",
            contact: "ogz.je@gmail.com"
          },
          {
            name: "Couple Judith et Dominique ATCHÉKPÉ",
            role : "Commissaire aux comptes",
            description : "Commissaire aux comptes de la zone Akpakpa.",
            image : "/api/placeholder/120/120",
            contact : "zone.cm-je@gmail.com"
          }
        ],
        fraternites: ["FRATERNITE ST JEAN EUDES", "FRATERNITE SAINTE RITA", "FRATERNITE ROSA MYSTICA", "FRATERNITE ST RAPHAEL", "FRATERNITE STS PIERRE & PAUL","FRATERNITE ST ANTOINE DE PADOUE", "FRATERNITE ST PIO", "FRATERNITE JESUS ECHARISTIE"]
      },
      // {
      //   name: "Zone Porto-Novo",
      //   color: "purple",
      //   responsables: [
      //     {
      //       name: "Couple ADJAHO Gérard & Célestine",
      //       role: "Animateur Principal de Zone (APZ)",
      //       description: "Coordination des fraternités de la zone Porto-Novo et animation des activités zonales.",
      //       image: "/api/placeholder/120/120"
      //     },
      //     {
      //       name: "Sœur Véronique ASSOGBA",
      //       role: "Secrétaire Générale de Zone (SGZ)",
      //       description: "Gestion administrative et communication au niveau de la zone Porto-Novo.",
      //       image: "/api/placeholder/120/120"
      //     },
      //     {
      //       name: "Frère Emmanuel TOSSAVI",
      //       role: "Trésorier Général de Zone (TGZ)",
      //       description: "Gestion financière et suivi des contributions de la zone Porto-Novo.",
      //       image: "/api/placeholder/120/120"
      //     }
      //   ],
      //   fraternites: ["Fraternité Sainte Famille", "Fraternité Saint Michel", "Fraternité Notre-Dame"]
      // },
      {
        name: "Zone Akpakpa", 
        color: "orange",
        responsables: [
          {
            name: "Couple Alida et Didier ADIO",
            role: "Animateur Principal de Zone (APZ)",
            description: "Coordination des fraternités de la zone Akpakpa et animation des activités zonales.",
            image: "/api/placeholder/120/120",
            contact : "apz.ak@gmail.com"
          },
          {
            name: "Couple Martine et Narcisse DANGBE ",   
            role: "Secrétaire Générale de Zone (SGZ)",
            description: "Gestion administrative et communication au niveau de la zone Akpakpa.",
            image: "/api/placeholder/120/120",
            contact : "zone-sg-ak@gmail.com"
          },          
           {
            name : "Couple Aimée et Johannes DANGBE ",
            role : "Chargé de Spiritualité et des Affaires Sociales (CSAS) ",
            description : "Prise en charges des activités spirituelles et sociales de la communauté au niveau diocésain.",
            image : "/api/placeholder/120/120",
            contact : "zone.spi-ak@gmail.com"
          },
          {
            name: "Couple Hortense Raymond et LOKO ",
            role: "Trésorier Général de Zone (TGZ)",
            description: "Gestion financière et suivi des contributions de la zone Akpakpa.",
            image: "/api/placeholder/120/120",
            contact: "zone.tg-ak@gmail.com"
          },
          { 
            name: "Couple Christèle et Arsène HOUESSOU",
            role: "Organisateur Général de Zone (OGZ)",
            description: "Organisateur Général des activités de la communauté au niveau de la zone Akpakpa, en charge de la logistique et de la coordination des événements.",
            image: "/api/placeholder/120/120",
            contact : "zone.og-ak@gmail"
          },
          {
            name: "Couple Marie-Emmanuelle et Paterne ADJIBI",
            role : "Commissaire aux comptes",
            description : "Commissaire aux comptes de la zone Akpakpa. ",
            image : "/api/placeholder/120/120",
            contact : "zone.cm-ak@gmail.com"
          }
        ],
        fraternites: ["FRATERNITE ST FRANCOIS D'ASSISE","FRATERNITE STE THERESE","FRATERNITE BON PASTEUR","FRATERNITE MARIE MERE DU SAUVEUR"]
      }
    ]
  };

  const statistics = [
    { number: "+150", label: "Couples membres", icon: Heart },
    { number: "+5", label: "Paroisses partenaires", icon: Church },
    { number: "3", label: "Zones géographiques", icon: MapPin },
    { number: " +15", label: "Années d'existence", icon: Calendar }
  ];

  const getColorClasses = (color) => {
    const colors = {
      blue: "bg-blue-500 text-blue-600",
      green: "bg-green-500 text-green-600", 
      amber: "bg-amber-500 text-amber-600",
      orange: "bg-orange-500 text-orange-600",
      red: "bg-red-500 text-red-600",
      pink: "bg-pink-500 text-pink-600"
    };
    return colors[color] || colors.blue;
  };

  const tabs = [
    { id: 'histoire', name: 'Notre Histoire', icon: Calendar },
    { id: 'valeurs', name: 'Nos Valeurs', icon: Star },
    { id: 'fondateurs', name: 'Les Fondateurs', icon: Users },
    { id: 'bureau', name: 'Bureau Actuel', icon: Award },
    { id: 'mission', name: 'Notre Mission', icon: Heart }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-fsf-primary via-fsf-secondary to-fsf-marriage text-white py-16">
        <div className="container mx-auto px-4">
          <Link 
            to="/" 
            className="inline-flex items-center space-x-2 text-white/80 hover:text-white transition-colors duration-200 mb-6"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Retour à l'accueil</span>
          </Link>
          
          <div className="flex items-center space-x-4 mb-8 text-justify">
            <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
              <Heart className="w-8 h-8 text-white" />
            </div>
            <div>
              <h1 className="text-4xl font-bold font-serif">À propos de nous</h1>
              <p className="text-xl text-white/80 mt-2">L'histoire et la mission des Fleurs de la Sainte Famille</p>
            </div>
          </div>

          {/* Statistiques */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {statistics.map((stat, index) => {
              const IconComponent = stat.icon;
              return (
                <div key={index} className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center">
                  <IconComponent className="w-6 h-6 text-white/80 mx-auto mb-2" />
                  <div className="text-2xl font-bold">{stat.number}</div>
                  <div className="text-sm text-white/80">{stat.label}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Navigation par onglets */}
      <div className="bg-white shadow-sm sticky top-0 z-10">
        <div className="container mx-auto px-4">
          <div className="flex space-x-8 overflow-x-auto">
            {tabs.map((tab) => {
              const IconComponent = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center space-x-2 py-4 px-2 border-b-2 whitespace-nowrap transition-all duration-200 ${
                    activeTab === tab.id
                      ? 'border-fsf-primary text-fsf-primary'
                      : 'border-transparent text-gray-600 hover:text-fsf-primary'
                  }`}
                >
                  <IconComponent className="w-4 h-4" />
                  <span className="font-medium">{tab.name}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Contenu */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-6xl mx-auto">
          
          {/* Onglet Histoire */}
          {activeTab === 'histoire' && (
            <div className="space-y-12 text-justify">
              <section className="bg-white rounded-2xl shadow-lg p-8">
                <div className="text-center mb-12 ">
                  <h2 className="text-3xl font-bold text-gray-800 mb-4">Notre Parcours</h2>
                  <p className="text-gray-600 max-w-3xl mx-auto leading-relaxed text-left">
                    Depuis plus de 20 ans, la communauté <strong>Fleurs de la Sainte Famille </strong> 
                    accompagne les couples et familles chrétiens dans leur cheminement spirituel. 
                    Découvrez les moments clés de notre histoire.
                  </p>
                </div>

                <div className="space-y-8 ">
                  {milestones.map((milestone, index) => {
                    const IconComponent = milestone.icon;
                    const colorClass = getColorClasses(milestone.color);
                    
                    return (
                      <div key={index} className="flex items-start space-x-6 text-justify">
                        <div className="flex-shrink-0">
                          <div className={`w-16 h-16 ${colorClass.split(' ')[0]} rounded-xl flex items-center justify-center shadow-lg`}>
                            <IconComponent className="w-8 h-8 text-white" />
                          </div>
                        </div>
                        
                        <div className="flex-1 text-justify">
                          <div className="flex items-center space-x-4 mb-2">
                            <h3 className="text-xl font-bold text-gray-800">{milestone.title}</h3>
                            <span className="bg-fsf-primary text-white px-3 py-1 rounded-full text-sm font-medium">
                              {milestone.year}
                            </span>
                          </div>
                          <p className="text-gray-600 leading-relaxed">{milestone.description}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </section>

              {/* Citation inspirante */}
              <section className="bg-gradient-to-r from-fsf-primary to-fsf-secondary text-white rounded-2xl p-8">
                <div className="text-center">
                  <Quote className="w-12 h-12 mx-auto mb-4 text-white/80" />
                  <blockquote className="text-xl italic mb-4">
                    "La famille qui prie ensemble reste ensemble. C'est dans cette conviction que nous avons fondé 
                    notre communauté, pour que chaque foyer devienne une petite église domestique."
                  </blockquote>
                  <cite className="text-white/80">- Frère Wilfrid, APD</cite>
                </div>
              </section>
            </div>
          )}

          {/* Onglet Valeurs */}
          {activeTab === 'valeurs' && (
            <div className="space-y-8">
              <section className="bg-white rounded-2xl shadow-lg p-8">
                <div className="text-center mb-12">
                  <h2 className="text-3xl font-bold text-gray-800 mb-4">Nos Valeurs Fondamentales</h2>
                  <p className="text-gray-600 max-w-3xl mx-auto leading-relaxed">
                    Les valeurs qui guident notre communauté depuis sa fondation et inspirent 
                    chacune de nos actions au service des familles chrétiennes.
                  </p>
                </div>

                <div className="grid md:grid-cols-2 gap-8 text-justify">
                  {values.map((value, index) => {
                    const IconComponent = value.icon;
                    const colorClass = getColorClasses(value.color);
                    
                    return (
                      <div key={index} className="bg-gray-50 rounded-xl p-6 border-l-4 border-fsf-primary">
                        <div className="flex items-start space-x-4">
                          <div className={`w-12 h-12 ${colorClass.split(' ')[0]} rounded-lg flex items-center justify-center shadow-md`}>
                            <IconComponent className="w-6 h-6 text-white" />
                          </div>
                          <div>
                            <h3 className="text-xl font-bold text-gray-800 mb-2">{value.title}</h3>
                            <p className="text-gray-600 leading-relaxed">{value.description}</p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </section>

              {/* Section Engagement */}
              <section className="bg-gradient-to-r from-green-50 to-blue-50 rounded-2xl p-8">
                <div className="text-center">
                  <Star className="w-16 h-16 text-green-600 mx-auto mb-4" />
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">Notre Engagement</h3>
                  <p className="text-gray-600 max-w-3xl mx-auto leading-relaxed mb-6 text-justify">
                    Nous nous engageons à accompagner chaque couple et chaque famille dans leur croissance 
                    spirituelle, en offrant un soutien concret, des formations adaptées et une communauté 
                    fraternelle où chacun peut s'épanouir dans sa foi. Notre apostolat est <strong> d’aider les familles à mener une vie conjugale épanouie dans la Fidélité à Dieu, la protection et la sauvegarde de la vie. Notre devise est  « Amour – Fidélité – Paix » </strong>.
                  </p>
                  <div className="grid md:grid-cols-3 gap-4 max-w-3xl mx-auto">
                    <div className="bg-white rounded-lg p-4">
                      <div className="text-2xl font-bold text-green-600">100%</div>
                      <div className="text-sm text-gray-600">Bénévole</div>
                    </div>
                    <div className="bg-white rounded-lg p-4">
                      <div className="text-2xl font-bold text-blue-600">24/7</div>
                      <div className="text-sm text-gray-600">Disponibilité</div>
                    </div>
                    <div className="bg-white rounded-lg p-4">
                      <div className="text-2xl font-bold text-amber-500">∞</div>
                      <div className="text-sm text-gray-600">Amour fraternel</div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          )}

          {/* Onglet Fondateurs */}
          {activeTab === 'fondateurs' && (
            <div className="space-y-8">
              <section className="bg-white rounded-2xl shadow-lg p-8">
                <div className="text-center mb-12">
                  <h2 className="text-3xl font-bold text-gray-800 mb-4">Nos Fondateurs</h2>
                  <p className="text-gray-600 max-w-3xl mx-auto leading-relaxed">
                    Découvrez les personnalités exceptionnelles qui ont posé les fondements 
                    de notre communauté avec foi, courage et dévouement.
                  </p>
                </div>

                <div className="space-y-8">
                  {founders.map((founder, index) => (
                    <div key={index} className="bg-gray-50 rounded-xl p-6">
                      <div className="flex flex-col md:flex-row items-start space-y-4 md:space-y-0 md:space-x-6">
                        <div className="flex-shrink-0">
                          <div className="w-24 h-24 bg-gradient-to-r from-fsf-primary to-fsf-secondary rounded-full flex items-center justify-center">
                            <Users className="w-12 h-12 text-white" />
                          </div>
                        </div>
                        <div className="flex-1 text-justify">
                          <h3 className="text-xl font-bold text-gray-800 mb-1">{founder.name}</h3>
                          <p className="text-fsf-primary font-semibold mb-3">{founder.role}</p>
                          <p className="text-gray-600 leading-relaxed">{founder.description}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            </div>
          )}

          {/* Onglet Bureau Actuel */}
          {activeTab === 'bureau' && (
            <div className="space-y-8">
              {/* Bureau Diocésain */}
              <section className="bg-white rounded-2xl shadow-lg p-8">
                <div className="text-center mb-12">
                  <h2 className="text-3xl font-bold text-gray-800 mb-4">Bureau Diocésain</h2>
                  <p className="text-gray-600 max-w-3xl mx-auto leading-relaxed">
                    L'équipe de direction qui coordonne l'ensemble des activités de la communauté 
                    FSF au niveau de l'Archidiocèse de Cotonou.
                  </p>
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  {currentBureau.diocesan.map((member, index) => (
                    <div key={index} className="bg-gradient-to-r from-blue-50 to-amber-50 rounded-xl p-6 border-l-4 border-fsf-primary">
                      <div className="flex flex-col sm:flex-row items-start space-y-4 sm:space-y-0 sm:space-x-4">
                        <div className="flex-shrink-0">
                          <div className="w-20 h-20 bg-gradient-to-r from-fsf-primary to-fsf-secondary rounded-full flex items-center justify-center">
                            <Award className="w-10 h-10 text-white" />
                          </div>
                        </div>
                        <div className="flex-1 text-justify">
                          <h3 className="text-lg font-bold text-gray-800 mb-1">{member.name}</h3>
                          <p className="text-fsf-primary font-semibold mb-2 text-sm">{member.role}</p>
                          <p className="text-gray-600 leading-relaxed text-sm mb-2">{member.description}</p>
                          <p className="text-xs text-gray-500">
                            <Mail className="w-3 h-3 inline mr-1" />
                            {member.contact}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </section>

              {/* Zones */}
              <section className="bg-white rounded-2xl shadow-lg p-8">
                <div className="text-center mb-12">
                  <h2 className="text-3xl font-bold text-gray-800 mb-4">Bureaux de Zone</h2>
                  <p className="text-gray-600 max-w-3xl mx-auto leading-relaxed">
                    Les équipes responsables qui animent et coordonnent les activités 
                    dans chacune des trois zones géographiques de notre communauté.
                  </p>
                </div>

                <div className="space-y-8">
                  {currentBureau.zones.map((zone, zoneIndex) => {
                    const colorClasses = {
                      blue: 'from-blue-500 to-blue-600 border-blue-500',
                      green: 'from-green-500 to-green-600 border-green-500',
                      amber: 'from-amber-500 to-amber-600 border-amber-500',
                      orange: 'from-orange-500 to-orange-600 border-orange-500'
                    };
                    
                    return (
                      <div key={zoneIndex} className={`bg-gradient-to-r ${colorClasses[zone.color]} rounded-2xl p-1`}>
                        <div className="bg-white rounded-xl p-6">
                          <div className="text-center mb-6">
                            <h3 className="text-2xl font-bold text-gray-800 mb-2">{zone.name}</h3>
                            <p className="text-gray-600 mb-4">
                              {zone.fraternites.length} fraternités : {zone.fraternites.join(', ')}
                            </p>
                          </div>
                          
                          <div className="grid md:grid-cols-3 gap-4">
                            {zone.responsables.map((responsable, index) => (
                              <div key={index} className="bg-gray-50 rounded-lg p-4">
                                <div className="text-center mb-3">
                                  <div className={`w-16 h-16 bg-gradient-to-r ${colorClasses[zone.color].split(' ')[0]} ${colorClasses[zone.color].split(' ')[1]} rounded-full flex items-center justify-center mx-auto mb-2`}>
                                    <Users className="w-8 h-8 text-white" />
                                  </div>
                                </div>
                                <div className="text-center">
                                  <h4 className="font-bold text-gray-800 mb-1 text-sm">{responsable.name}</h4>
                                  <p className="text-xs font-semibold text-gray-600 mb-2">{responsable.role}</p>
                                  <p className="text-xs text-gray-600 leading-relaxed">{responsable.description}</p>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </section>

              {/* Section Contact */}
              <section className="bg-gradient-to-r from-fsf-primary to-fsf-secondary text-white rounded-2xl p-8">
                <div className="text-center">
                  <Users className="w-16 h-16 mx-auto mb-4 text-white/80" />
                  <h3 className="text-2xl font-bold mb-4">Contactez nos Responsables</h3>
                  <p className="text-white/90 max-w-3xl mx-auto leading-relaxed mb-6">
                    N'hésitez pas à prendre contact avec les membres du bureau diocésain ou de votre zone 
                    pour toute question, suggestion ou pour rejoindre notre belle famille spirituelle.
                  </p>
                  <div className="grid md:grid-cols-3 gap-4 max-w-2xl mx-auto">
                    <div className="bg-white/10 rounded-lg p-4 backdrop-blur-sm">
                      <h4 className="font-semibold mb-1">Bureau Diocésain</h4>
                      <p className="text-sm text-white/80">Coordination générale</p>
                    </div>
                    <div className="bg-white/10 rounded-lg p-4 backdrop-blur-sm">
                      <h4 className="font-semibold mb-1">Zones</h4>
                      <p className="text-sm text-white/80">Animation locale</p>
                    </div>
                    <div className="bg-white/10 rounded-lg p-4 backdrop-blur-sm">
                      <h4 className="font-semibold mb-1">Fraternités</h4>
                      <p className="text-sm text-white/80">Vie communautaire</p>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          )}

          {/* Onglet Mission */}
          {activeTab === 'mission' && (
            <div className="space-y-8">
              <section className="bg-white rounded-2xl shadow-lg p-8">
                <div className="text-center mb-12">
                  <h2 className="text-3xl font-bold text-gray-800 mb-4">Notre Mission</h2>
                  <p className="text-gray-600 max-w-3xl mx-auto leading-relaxed">
                    Découvrez notre raison d'être et les objectifs qui animent notre action 
                    quotidienne au service des familles chrétiennes.
                  </p>
                </div>

                <div className="grid md:grid-cols-2 gap-8 text-justify">
                  <div className="space-y-6">
                    <div className="bg-blue-50 rounded-xl p-6">
                      <h3 className="text-xl font-bold text-blue-800 mb-3">Évangéliser les Familles</h3>
                      <p className="text-gray-600 leading-relaxed">
                        Annoncer la Bonne Nouvelle du Christ dans les foyers, en aidant les couples 
                        à découvrir la beauté du mariage chrétien et la joie de la vie familiale 
                        centrée sur l'Évangile.
                      </p>
                    </div>

                    <div className="bg-green-50 rounded-xl p-6">
                      <h3 className="text-xl font-bold text-green-800 mb-3">Accompagner les Couples</h3>
                      <p className="text-gray-600 leading-relaxed">
                        Offrir un accompagnement personnalisé aux couples dans toutes les étapes 
                        de leur vie conjugale : préparation au mariage, premiers temps du mariage, 
                        difficultés, éducation des enfants.
                      </p>
                    </div>

                    <div className="bg-amber-50 rounded-xl p-6">
                      <h3 className="text-xl font-bold text-amber-700 mb-3">Former et Éduquer</h3>
                      <p className="text-gray-600 leading-relaxed">
                        Proposer des formations bibliques, spirituelles et pratiques pour enrichir 
                        la vie de foi des familles et les aider à grandir dans la sainteté.
                      </p>
                    </div>
                  </div>

                  <div className="space-y-6">
                    <div className="bg-orange-50 rounded-xl p-6">
                      <h3 className="text-xl font-bold text-orange-800 mb-3">Créer la Communion</h3>
                      <p className="text-gray-600 leading-relaxed">
                        Tisser des liens fraternels authentiques entre les familles, en créant 
                        une véritable communauté où chacun peut trouver soutien et encouragement.
                      </p>
                    </div>

                    <div className="bg-red-50 rounded-xl p-6">
                      <h3 className="text-xl font-bold text-red-800 mb-3">Servir l'Église</h3>
                      <p className="text-gray-600 leading-relaxed">
                        Collaborer activement avec les paroisses et diocèses pour soutenir la 
                        pastorale familiale et contribuer à la mission évangélisatrice de l'Église.
                      </p>
                    </div>

                    <div className="bg-pink-50 rounded-xl p-6">
                      <h3 className="text-xl font-bold text-pink-800 mb-3">Transformer la Société</h3>
                      <p className="text-gray-600 leading-relaxed">
                        Être un ferment de renouveau dans la société en témoignant des valeurs 
                        évangéliques et en promouvant une culture de vie et d'amour.
                      </p>
                    </div>
                  </div>
                </div>
              </section>

              {/* Vision d'avenir */}
              <section className="bg-gradient-to-r from-fsf-primary to-fsf-secondary text-white rounded-2xl p-8">
                <div className="text-center">
                  <Globe className="w-16 h-16 mx-auto mb-4 text-white/80" />
                  <h3 className="text-2xl font-bold mb-4">Notre Vision pour l'Avenir</h3>
                  <p className="text-white/90 max-w-3xl mx-auto leading-relaxed mb-6 text-justify">
                    Nous rêvons d'un monde où chaque famille chrétienne rayonne de l'amour du Christ, 
                    où les couples trouvent dans leur union un chemin de sainteté, et où les enfants 
                    grandissent dans la joie de connaître Jésus. Notre vision est celle d'une 
                    transformation de la société par la famille, cellule fondamentale de l'Église et de l'humanité.
                  </p>
                  {/* <Link
                    to="/contact"
                    className="inline-block bg-white text-fsf-primary px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-200"
                  >
                    Rejoignez notre mission
                  </Link> */}
                </div>
              </section>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default About;